import type { TFunction } from 'i18next';
import { mapCountryCodeToCountryKey } from 'tradera/localization/countries';
import { areCountryCodesIso2Equal } from 'tradera/localization/countrycode';
import { isInternationalShippingToCountryAllowed } from 'tradera/utils/allowed-buyer-region';

export const translateBuyerRegionText = (
    t: TFunction,
    allowedBuyerRegion: string,
    buyerCountryCode: string,
    sellerCountryCode: string,
    hideCountrySpecificTexts: boolean
) => {
    if (
        !hideCountrySpecificTexts &&
        isInternationalShippingToCountryAllowed(
            allowedBuyerRegion,
            buyerCountryCode
        )
    ) {
        if (areCountryCodesIso2Equal(buyerCountryCode, sellerCountryCode)) {
            return t('vip_buyer_region_text_price_within_country', {
                country: t(mapCountryCodeToCountryKey(buyerCountryCode))
            });
        } else {
            return t('vip_buyer_region_text_country_price', {
                country: t(mapCountryCodeToCountryKey(buyerCountryCode))
            });
        }
    }

    switch (allowedBuyerRegion) {
        case 'Sweden':
            return t('vip_buyer_region_text_sweden');
        case 'Nordic':
            return t('vip_buyer_region_text_nordic');
        case 'EU':
            return t('vip_buyer_region_text_eu');
        case 'International':
            return t('vip_buyer_region_text_international');

        default:
            return allowedBuyerRegion;
    }
};
